export type AdminSection =
  | 'company'
  | 'top'
  | 'mainImage'
  | 'clientBox'
  | 'institutional'
  | 'footer'
  | 'specialties'
  | 'pdf'
  | 'presets';

interface AdminSidebarProps {
  active: AdminSection;
  onChange: (section: AdminSection) => void;
}

const sections: { key: AdminSection; label: string; icon: string }[] = [
  { key: 'company', label: 'Empresa', icon: 'ri-building-line' },
  { key: 'top', label: 'Topo', icon: 'ri-layout-top-line' },
  { key: 'mainImage', label: 'Imagem Principal', icon: 'ri-image-line' },
  { key: 'clientBox', label: 'Caixa do Cliente', icon: 'ri-user-line' },
  { key: 'institutional', label: 'Institucional', icon: 'ri-article-line' },
  { key: 'footer', label: 'Rodapé', icon: 'ri-layout-bottom-line' },
  { key: 'specialties', label: 'Especialidades', icon: 'ri-star-line' },
  { key: 'presets', label: 'Biblioteca / Presets', icon: 'ri-folder-image-line' },
  { key: 'pdf', label: 'PDF', icon: 'ri-file-pdf-line' },
];

export default function AdminSidebar({ active, onChange }: AdminSidebarProps) {
  return (
    <nav className="w-60 flex-shrink-0 bg-brand-darker border-r border-brand-gold/10 overflow-y-auto flex flex-col">
      <div className="p-5 border-b border-brand-gold/10">
        <div className="flex items-center gap-3">
          <div className="w-8 h-8 flex items-center justify-center">
            <i className="ri-settings-3-line text-brand-gold text-xl" />
          </div>
          <div>
            <h1 className="text-white font-semibold text-sm">Painel Admin</h1>
            <p className="text-brand-text-muted text-xs">Template</p>
          </div>
        </div>
      </div>
      <div className="p-3 space-y-1 flex-1">
        {sections.map((s) => {
          const isActive = active === s.key;
          return (
            <button
              key={s.key}
              onClick={() => onChange(s.key)}
              className={`w-full flex items-center gap-3 px-3 py-2.5 rounded-md text-sm transition-colors cursor-pointer ${
                isActive
                  ? 'bg-brand-gold/15 text-brand-gold font-medium'
                  : 'text-brand-text-muted hover:text-white hover:bg-brand-dark/40'
              }`}
            >
              <div className="w-5 h-5 flex items-center justify-center">
                <i className={`${s.icon} ${isActive ? 'text-brand-gold' : ''}`} />
              </div>
              {s.label}
            </button>
          );
        })}
      </div>
      <div className="p-3 border-t border-brand-gold/10 space-y-1">
        <a
          href="/admin/library"
          className="w-full flex items-center gap-3 px-3 py-2.5 rounded-md text-sm transition-colors cursor-pointer text-brand-text-muted hover:text-white hover:bg-brand-dark/40"
        >
          <div className="w-5 h-5 flex items-center justify-center">
            <i className="ri-folder-image-line" />
          </div>
          Biblioteca
        </a>
        <a
          href="/admin/proposals"
          className="w-full flex items-center gap-3 px-3 py-2.5 rounded-md text-sm transition-colors cursor-pointer text-brand-text-muted hover:text-white hover:bg-brand-dark/40"
        >
          <div className="w-5 h-5 flex items-center justify-center">
            <i className="ri-file-list-3-line" />
          </div>
          Propostas
        </a>
      </div>
    </nav>
  );
}